<template>
  <v-card flat outlined rounded="lg" height="100%" color="cardbg" elevation="10">
    <v-card-title
      color="primary"
      :style="`padding: calc(${scale} * 0.4rem);
       line-height: calc(${scale} * 0.75rem); font-size: calc(${scale} * 0.7rem);`"
      class="font-weight-medium d-flex justify-space-between"
    >
      <span class="titlecolor--text">Worst 3 Parts</span>
      <span class="subtitlecolor--text">{{ yesterday }}</span>
    </v-card-title>
    <v-card-text :style="`height: 90%; padding: calc(${scale} * 0.1rem) calc(${scale} * 0.4rem);`">
      <div style="height: 100%;">
        <WidgetLoading v-if="loading" />
        <table
          style="text-align: center;"
          class="w-full"
          :style="`font-size: calc(${scale} * 0.7rem); line-height: 1.6;`"
          v-else
        >
          <tr
            class="subtitlecolor--text font-weight-regular text-uppercase text-left"
            :style="`font-size: calc(${scale} * 0.7rem);`"
          >
            <th>Part Name</th>
            <th>Rej (%)</th>
            <th>PPM</th>
          </tr>
          <tr class="text-left titlecolor--text" v-for="(part, i) in worstpart" :key="i"
          :style="`font-size: calc(${scale} * 0.8rem);`">
            <td>{{ part.name }}</td>
            <td>{{ part.rejected }}</td>
            <td>{{ part.ppm }}</td>
          </tr>
        </table>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import {
  mapState, mapActions, mapGetters, mapMutations,
} from 'vuex';
import { formatDate } from '@shopworx/services/util/date.service';
import WidgetLoading from '../WidgetLoading.vue';

export default {
  name: 'WorstPart',
  props: { scale: { type: Number, default: 1 }, unit: { type: String } },
  components: { WidgetLoading },
  data() {
    return {
      worstpart: [],
      loading: false,
      yesterday: '',
      rawReportData: [],
      fetchDataSerial: 0,
    };
  },
  computed: {
    ...mapState('cellwiseQualityDashboard', ['shifts', 'machines', 'serverTime', 'dataFromJSON', 'currentDate', 'selectedCell']),
    ...mapGetters('cellwiseQualityDashboard', ['firstShift', 'activeSite']),

    cellname() {
      return this.selectedCell || this.$route.query.selectedcell || '';
    },
    machinesInCell() {
      if (!this.cellname || !this.machines) return [];
      return this.machines
        .filter((m) => m.machinecell === this.cellname
         || m.cellname === this.cellname || m.cell === this.cellname)
        .map((m) => m.machinename);
    },
  },
  watch: {
    cellname: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          if (this.rawReportData.length > 0) {
            this.setOptions(this.rawReportData);
          } else if (!this.dataFromJSON) {
            this.fetchData();
          }
        }
      },
    },
    currentDate(newVal, oldVal) {
      if (newVal && newVal !== oldVal && !this.dataFromJSON) {
        this.fetchData();
      }
    },
  },
  mounted() {
    if (this.dataFromJSON) this.dummydata(); else this.fetchData();
  },
  methods: {
    ...mapActions('cellwiseQualityDashboard', ['allShifts', 'getMachines', 'getReports', 'getFileData']),
    ...mapMutations('cellwiseQualityDashboard', ['setWorstPart']),

    async dummydata() {
      const res = await this.getFileData('jsondata/worstparts.json');
      const startdate = new Date(); startdate.setDate(startdate.getDate() - 1);
      this.setTitle(startdate);
      this.rawReportData = res.reportData || [];
      this.setOptions(this.rawReportData);
    },

    async fetchData() {
      this.fetchDataSerial += 1;
      const requestSerial = this.fetchDataSerial;
      this.loading = true;

      if (!this.machines || this.machines.length === 0) {
        await this.getMachines('?sortquery=sortindex==1');
      }

      if (!this.shifts || this.shifts.length <= 0) await this.allShifts();

      let targetYYYYMMDD = 0;
      let starttimeTs = 0;

      if (!this.currentDate) {
        if (requestSerial === this.fetchDataSerial) {
          this.loading = false;
        }
        return;
      }

      const dateStr = String(this.currentDate);
      const year = parseInt(dateStr.slice(0, 4), 10);
      const month = parseInt(dateStr.slice(4, 6), 10) - 1;
      const day = parseInt(dateStr.slice(6, 8), 10);

      const targetDate = new Date(year, month, day);
      targetDate.setDate(targetDate.getDate() - 1);

      targetYYYYMMDD = parseInt(
        `${targetDate.getFullYear()}${String(targetDate.getMonth() + 1).padStart(2, '0')}${String(targetDate.getDate()).padStart(2, '0')}`,
        10,
      );
      starttimeTs = targetDate.getTime();

      this.setTitle(starttimeTs);

      let siteId = this.activeSite
       || this.$store.state.user?.activeSite || this.$store.state.auth?.user?.site_id;
      if (!siteId) {
        try {
          const swxUser = JSON.parse(localStorage.getItem('user') || '{}');
          siteId = swxUser?.site_id || swxUser?.site?.id || swxUser?.customer?.site_id;
        } catch (e) { /* ignore */ }
      }

      const payload = {
        start: targetYYYYMMDD,
        end: targetYYYYMMDD,
        siteid: siteId || 0,
        singledaterange: false,
        all: true,
      };

      const reportName = 'dailyanalysis';
      const result = await this.getReports({ reportName, payload });
      if (requestSerial !== this.fetchDataSerial) return;
      try {
        const parsed = typeof result === 'string' ? JSON.parse(result) : result;
        this.rawReportData = parsed.reportData || parsed || [];
        this.setOptions(this.rawReportData);
      } catch (e) {
        if (requestSerial !== this.fetchDataSerial) return;
        this.rawReportData = [];
        this.setOptions([]);
      }
      if (requestSerial === this.fetchDataSerial) {
        this.loading = false;
      }
    },

    setOptions(data) {
      let processedData = data;

      if (typeof processedData === 'string') {
        try { processedData = JSON.parse(processedData); } catch (e) { processedData = {}; }
      }

      let records = [];
      if (processedData.reportData) {
        records = typeof processedData.reportData === 'string'
          ? JSON.parse(processedData.reportData).reportData
          : processedData.reportData;
      } else {
        records = Array.isArray(processedData) ? processedData : [];
      }

      const databycellname = records.filter((d) => {
        if (!this.cellname) return true;
        return this.machinesInCell.includes(d.machinename);
      });

      const parts = databycellname.map((d) => d.partname).filter((p) => p && p !== 'No Plan');
      const uniqueparts = [...new Set(parts)];
      const result = [];

      uniqueparts.forEach((partname) => {
        let rejected = 0; let produced = 0; let partnumber = '-';

        databycellname.forEach((d) => {
          if (d.partname === partname) {
            produced += (d.produced || 0);
            rejected += (d.rejectionppm * d.produced) / 1000000;
            partnumber = d.partnumber || partname;
          }
        });

        let ppm = 0; let rejinper = 0;
        if (produced > 0) {
          ppm = Math.floor((rejected / produced) * 1000000);
          rejinper = Math.round((rejected / produced) * 10000) / 100;
        }

        result.push({
          number: partnumber, name: partname, rejected: rejinper, produced, ppm,
        });
      });

      const sortResult = result.sort((a, b) => b.rejected - a.rejected);
      if (typeof this.setWorstPart === 'function') this.setWorstPart(sortResult);
      this.worstpart = sortResult.slice(0, 3);
    },

    setTitle(val) {
      this.yesterday = formatDate(val, 'dd/MM/yyyy');
    },
  },
};
</script>

<style>
.w-full { width: 100%; }
</style>
